module.exports = __webpack_public_path__ + "img/icon_attractive_basis.986049ce.svg";